export default "__VITE_ASSET__ffab0df3__"